<template>
  <v-container id="expenses" fluid tag="section">
    <div class="text-right">
      <v-btn color="cyan" @click="showFilter = !showFilter" small>
        <v-icon>mdi-filter</v-icon>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="light-blue" small>
            <h3>
              {{ $i18n.t("Action") }}
              <v-icon>mdi-menu-down</v-icon>
            </h3>
          </v-btn>
        </template>
        <v-list>
          <v-list-item :to="'/expense/create'">
            <v-icon>mdi-plus</v-icon>
            <v-list-item-title>{{ $i18n.t("Add New") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <v-row justify="center" v-if="showFilter">
      <v-col cols="12" md="12">
        <base-material-card
          color="light-blue"
          icon="mdi-filter"
          class="px-3 py-1 small-icon"
          v-if="showFilter"
        >
          <div class="filter-close">
            <v-btn
              color="black"
              class="mr-0"
              fab
              small
              text
              @click="showFilter = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-row>
            <v-col cols="12" sm="12" md="4" lg="3">
              <v-select
                :label="$i18n.t('Account')"
                class="purple-input"
                v-model="filter.account"
                :items="accountList"
                item-text="name"
                item-value="value"
                clearable
              ></v-select>
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="3">
              <z-vendor-select
                clearable
                class="purple-input"
                v-model="filter.vendor_id"
              />
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="3">
              <z-vehicle-select
                idOnly
                clearable
                class="purple-input"
                v-model="filter.vehicle_id"
              />
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="3">
              <v-text-field
                :label="$i18n.t('Invoice No.')"
                class="purple-input"
                v-model="filter.invoiceNo"
                clearable
              />
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="3">
              <z-driver-select
                idOnly
                clearable
                class="purple-input"
                v-model="filter.driver_id"
              ></z-driver-select>
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="3" class="text-right">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-0"
                    color="grey darken"
                    fab
                    text
                    small
                    @click="clear(1)"
                    style="margin-right: 10px !important"
                    v-on="on"
                  >
                    <v-icon>mdi-cached</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Clear Filter") }}</span>
              </v-tooltip>
              <v-btn
                color="success"
                class="mr-0"
                fab
                small
                dark
                @click="search()"
                :loading="loading"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>

    <v-btn
      v-if="grid != undefined && !grid.records"
      class="text-center secondary--text pa-10"
      text
      color="primary"
      style="width: 100%"
      :loading="loading"
      >{{ $i18n.t("No records available") }}</v-btn
    >

    <base-material-card
      icon="mdi-card-text-outline"
      :title="$i18n.t('Expenses')"
      class="px-5 py-3 small-icon"
      v-if="grid.records"
    >
      <z-grid-record :grid="grid" />

      <v-simple-table dense>
        <template v-slot:default>
          <thead class="thead">
            <tr>
              <th class="text-left">
                {{ $i18n.t("Account") }}
              </th>
              <th class="text-left">
                {{ $i18n.t("Particulars") }}
              </th>
              <th class="text-left">
                {{ $i18n.t("Payment Date") }}
              </th>
              <th class="text-left">
                {{ $i18n.t("Affect From") }}
              </th>
              <!-- <th class="text-left">
                {{ $i18n.t("Till") }}
              </th> -->
              <th class="text-left">
                {{ $i18n.t("Title") }}
              </th>
              <!-- <th class="text-left">
                {{ $i18n.t("For Month") }}
              </th> -->
              <th class="text-left">
                {{ $i18n.t("Bill No") }}
              </th>
              <th class="text-left">
                {{ $i18n.t("Vehicle") + " / " + $i18n.t("Driver") }}
              </th>
              <th class="text-right">
                {{ $i18n.t("Total") }}
              </th>
              <th class="text-right">
                {{ $i18n.t("Taxes") }}
              </th>
              <th class="text-center">
                {{ $i18n.t("Vendor") }}
              </th>
              <th class="text-right">{{ $i18n.t("Action") }}</th>
            </tr>
          </thead>
          <expense-row
            v-for="item in grid.rows"
            :key="item._id"
            :value="item"
            @reload="reload"
            :refresh="refresh"
          />
        </template>
      </v-simple-table>

      <v-container>
        <v-pagination
          v-model="grid.page"
          class="my-4"
          :length="grid.total"
          total-visible="10"
          @input="showPage"
        ></v-pagination>
      </v-container>
    </base-material-card>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import ExpenseRow from "@/views/expense/ExpenseRow.vue";
import init from "@/store/common/module/init";

@Component({
  name: "Expenses",
  components: { ExpenseRow },
})
export default class Expenses extends Vue {
  grid = { page: 0, rows: [] };
  url = "/api/expense/grid?&";
  showFilter = false;
  filterUrl = "";
  on = null;
  page = 1;
  rows = 50;

  filter = {
    account: null,
    vendor_id: null,
    vehicle_id: "",
    invoiceNo: "",
    driver_id: "",
  };

  accountList = [
    {
      name: "Credit Note",
      value: "CreditNote",
    },
    {
      name: "Driver Cash Advance",
      value: "DriverCashAdvance",
    },
    {
      name: "Driver Expense",
      value: "DriverExpense",
    },
    {
      name: "Driver Fund Return",
      value: "DriverFundReturn",
    },
    {
      name: "General",
      value: "General",
    },
    {
      name: "Office Expense",
      value: "OfficeExpense",
    },
    {
      name: "Rent",
      value: "Rent",
    },
    {
      name: "Salary",
      value: "Salary",
    },
    {
      name: "Supplier Advance",
      value: "SupplierAdvance",
    },
    {
      name: "Supplier Fund Return",
      value: "SupplierFundReturn",
    },
    {
      name: "Vehicle Expense",
      value: "VehicleExpense",
    },
  ];

  get loading() {
    return common.loading;
  }

  get gridHeight() {
    return this.windowHeight > 500 ? this.windowHeight - 150 : 300;
  }

  get itemHeight() {
    return this.windowWidth > 960 ? 75 : 240;
  }

  async mounted() {
    await init.getUrlParameter("_account");
    if (init.urlParam) {
      if (!this.filter) this.filter = {};
      this.filter.account = init.urlParam;
    }
    this.search();
  }

  async showPage(page) {
    common.setLoading(true);
    this.page = page;
    try {
      const grid = await doGet(
        this.url + "rows=" + this.rows + "&page=" + page + this.filterUrl
      );
      if (grid.rows && grid.rows.length > 0) {
        // for (let i = 0; i < grid.rows.length; i++) {
        //   grid.rows[i].selected = false;
        //   grid.rows[i]._showAssign = false;
        // }
      }
      this.grid = grid;
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async clear() {
    this.filter = {
      account: null,
      vendor_id: null,
      vehicle_id: "",
      invoiceNo: "",
      driver_id: "",
    };

    this.page = 1;
    this.search();
  }

  async refresh(__i) {
    if (__i == 1) {
      this.search();
    }
  }

  async search() {
    this.filterUrl = "";
    if (this.filter.account)
      this.filterUrl += "&accountCode=" + this.filter.account;
    if (this.filter.vendor_id)
      this.filterUrl += "&vendor=" + this.filter.vendor_id;
    if (this.filter.vehicle_id)
      this.filterUrl += "&vehicle_id=" + this.filter.vehicle_id;
    if (this.filter.invoiceNo)
      this.filterUrl += "&invoice=" + this.filter.invoiceNo;
    if (this.filter.driver_id)
      this.filterUrl += "&driver_id=" + this.filter.driver_id;
    common.setLoading(true);
    await this.showPage(1);
  }

  async deleteExpense(expense_id) {
    common.setLoading(true);
    try {
      await doGet("/api/expense/" + expense_id + "/delete/");
      common.showMessage("Deleted Successfully");
      await this.search();
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  isSet(_key) {
    if (
      _key != null &&
      _key != undefined &&
      _key != "null" &&
      _key != "undefined" &&
      _key != ""
    ) {
      return true;
    }
    return false;
  }

  async reload() {
    this.showPage(this.page);
  }

  closeDialog() {
    this.showBulkUpdateDialog = false;
    this.payload = {};
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
.dialog {
  position: fixed;
  top: 100px;
  width: 60%;
  z-index: 10;
  margin-left: 15%;
}
.sticky-bottom {
  position: sticky;
  bottom: 0;
  background-color: white;
  border-top: 1px solid #dfdfdf;
}
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 2;
}
tbody:nth-child(even) {
  background: #fafafa;
}
</style>
